import { memo, useEffect, useState } from 'react';
import { useWindowSize } from '../Common/CommonHooks';
import FootballTopBlock from '../Football/Common/FootballTopBlock';
import MarksixTopBlock from '../Marksix/Common/MarksixTopBlock';
import RacingTopBlock from '../Racing/Common/RacingTopBlock';
import { Swipe } from '../Common/ui-components/NewsBanner/swipe';
import { useBanners } from '../Common/ui-components/NewsBanner/bannerAdScript';

const getProductCode = (prod) => {
    switch (prod) {
        case "racing":
            return "HR";
        case "football":
            return "FB";
        case "marksix":
            return "LY";
    }
    return "GL";
}

const Banner = memo((props) => {
    const [news, setNews] = useState();
    const { isMobileSize } = useWindowSize();

    const bannersTr = useBanners({
        enable: props.enable,
        product: getProductCode(props.Product),
        raceNo: props.raceNo
    });
    
    // get meeting list when didmount
    useEffect(() => {
        loadNews()
    }, []);

    const loadNews = () => {
        if (props.Product) {
            let temp = null;
            switch (props.Product) {
                case 'racing':
                    temp = <RacingTopBlock />
                    break;
                case 'football':
                    temp = <FootballTopBlock />
                    break;
                case 'marksix':
                    temp = <MarksixTopBlock />
                    break;
                default:
                    temp = geneWinNews();
            }
            setNews(temp);
        }
    };

    const geneWinNews = () => {
        return <div>ewin banner</div>;
    };

    let infoWidth=document.querySelector('.leftMenuMain')?.offsetWidth || 222;
    infoWidth = Math.max(198, infoWidth);

    return !window.globalConfig.IS_EWIN2 && bannersTr?.length > 0 ?
        <div id="topBannerDiv" className={`topBanner ${props.enable ? 'show' : 'hide'}`}>
            <div id="divTopBanner">
                <div id="info_top_block">{!isMobileSize && news}</div>
                <div className="info_top_promo" style={{width:`calc(100% - ${isMobileSize?0:infoWidth}px)`}}>
                   <Swipe bannerArr={bannersTr} />
                </div>
            </div>
        </div>
    : null;
});

Banner.displayName = "Banner";

export default Banner;
